import { datadogRum } from '@datadog/browser-rum';
import BoletoDto from '@/models/dto/BoletoDto';
import BoletoResource from '@/models/resources/BoletoResource';
import HttpService from './HttpService';
import { ApiResponse } from '@/models/resources/ApiResponse';

class BoletoService extends HttpService {
  public async gerar(
    api: string,
    dividaId: number,
    numeroParcela: number,
  ): Promise<BoletoResource> {
    datadogRum.addAction('sys:boleto_service:gerar_boleto');
    const response = await this.post<ApiResponse<BoletoDto>>(`/api/${api}/Consumidor/Boleto/${dividaId}/${numeroParcela}/Gerar`);
    return new BoletoResource(response.data);
  }
}

const boletoService = new BoletoService();
export default boletoService;
